import { Divider as MuiDivider } from "@mui/material";
import React from "react";

const Divider: React.FC = () => <MuiDivider flexItem style={styles.divider} />
export default Divider

const styles = {
  divider: {
    width: "100%",
    marginBottom: "16px",
    borderColor: "inherit"
  }
}
